"use strict";
/**
 * @author Meiblorn (Vadim Fedorenko) <meiblorn@gmail.com | admin@meiblorn.com> on 11/05/16.
 */
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var components_1 = require("./components");
__export(require("./components/index"));
exports.default = {
    directives: components_1.MN_FULLPAGE_DIRECTIVES.slice()
};
//# sourceMappingURL=ngx-fullpage.js.map


//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/~/ngx-fullpage/ngx-fullpage.js
// module id = ../../../../ngx-fullpage/ngx-fullpage.js
// module chunks = 4